/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { errorPayoutConfig } from '../../config/error.config';

export interface IErrorPayoutPluginMethods extends IPluginMethodMap {
  getErrorPayoutSync(args?: any): any;
}

export class ErrorPayoutPlugin implements IAgentPlugin {
  readonly methods: IErrorPayoutPluginMethods;

  constructor() {
    this.methods = {
      getErrorPayoutSync: this.getErrorPayoutSync.bind(this),
    };
  }

  getErrorPayoutSync(args?: any) {
    return {
      error: errorPayoutConfig,
    };
  }
}
